import React from 'react'

const Marketfaq = () => {
  return (
    <div>
        <div className="text-center py-5">
              <h3 className="py-3">CPAP Market FAQ.</h3>
              <h3 className="font-bold py-5 text-[36px]">CPAP Education</h3>
              <h3 className="font-bold py-3 text-[18px]">Q: Which machine is the quietest?</h3>
              <h3>A: All new machines these days are extremely quiet...Read more</h3>
              <h3 className="font-bold py-3 text-[18px]">Q: What is a BiLevel (BiPAP) Machine?</h3>
              <h3>A: A BiLevel machine, or as some call it a BiPAP... Read more</h3>
              <h3 className="font-bold py-3 text-[18px]">Q: Are there DC/Battery operated CPAP machines?</h3>
               <h3>A: Most CPAP/APAP/Bipap-Vpap machine are designed to operate... Read more</h3>
            </div>
    </div>
  )
}

export default Marketfaq
